import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import Navbar from '../Navbar';
import { MdAddToPhotos } from "react-icons/md";
import Menu_Items from '../Menu_Items';

function Create_user() {
    const { id } = useParams();
    const [inval, setinval] = useState({ com_id: id });
    const navigate = useNavigate();

    const menus = [
        {
            name: 'Integrations',
            id
        },
        {
            name: 'Users',
            id
        }
    ];
    const handledata = (e) => {
        setinval({ ...inval, [e.target.id]: e.target.value });
    };
    const submit = async () => {
        await axios.post(`/user/add`, inval).then((res) => {
            navigate(`/company/users/${id}`);
        })
            .catch((err) => {
                toast.error('Error', {
                    autoClose: 2000, // 2 seconds
                });

            });

    };
    return (
        <div className='container df fdc jb ac'>
            <Navbar />
            <div className='main_box df'>
                <Menu_Items menu={menus} />
                <div className='content df fdc ac'>
                    <div className='page_header df jb ac'>
                        <div className='w90 df ac'><MdAddToPhotos className='page_icon db' />
                            <p>Crete Users</p></div>
                    </div>
                    <div className='box'>
                        <div className='create_box'>
                            <div>
                                <label htmlFor='name'>Name</label>
                                <input type='search' id='name' onChange={(e) => { handledata(e) }} placeholder='Enter Name' />
                            </div>
                            <div>
                                <label htmlFor='mail'>E-Mail Id</label>
                                <input type='search' id='mail' onChange={(e) => { handledata(e) }} placeholder='Enter E-Mail' />
                            </div>
                            <div>
                                <label htmlFor='mobile'>Mobile No</label>
                                <input type='number' id='mobile' onChange={(e) => { handledata(e) }} placeholder='Enter Mobile No' />
                            </div>
                            <div>
                                <label htmlFor='userid'>User Id</label>
                                <input type='search' id='uname' onChange={(e) => { handledata(e) }} placeholder='Enter User Id' />
                            </div>
                            <div>
                                <label htmlFor='password'>Password</label>
                                <input type='search' id='password' onChange={(e) => { handledata(e) }} placeholder='Enter Password' />
                            </div>
                            <div>
                                <label htmlFor='role'>Role</label>
                                <select id='role' onChange={(e) => { handledata(e) }}>
                                    <option value={""}>Please Select</option>
                                    <option value={'Admin'}>Admin</option>
                                    <option value={'Integ Special'}>Integ Special</option>
                                    <option value={'Integ User'}>Integ User</option>
                                    <option value={'Integ Monitor'}>Integ Monitor</option>
                                </select>
                            </div>
                            <div >
                                <label htmlFor='sso'>SSO</label>
                                <select id='sso' onChange={(e) => { handledata(e) }}>
                                    <option value={""}>Please Select</option>
                                    <option value={'yes'}>Yes</option>
                                    <option value={'no'}>No</option>
                                </select>
                            </div>
                        </div>
                        <div className='w100 h10 df jc ac'>
                            <button className='btn green' onClick={submit}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>



        </div >

    )
}

export default Create_user;